<template>
  <div>
    <Navbar></Navbar>
    <div class="container mt-3 mt-lg-5">

      <!-- TITLE -->
      <div class="row mb-3">
        <div class="col-md-12 mb-3">
          <router-link to="/user/gradients" class="btn btn-link btn-micint-xr ripple ripple-primary m-0">
            <i class="material-icons-outlined">arrow_left</i>
            Go back
          </router-link>
        </div>
        <div class="col-md-12">
          <vue-aos animation-class="animate__animated animate__flipInX">
            <h1 class="typography-headline-lg fw-500 text-uppercase">{{ gradient.name }}</h1>
          </vue-aos>
        </div>
      </div>

      <!-- GRADIENT -->
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="gradient gradient-generator" v-if="gradient.color3" id="expanded-gradient"
               :class="[ isExpanded ? 'section-overlay' : '']"
               :style="{ 'background': gradient.gradientType + '(' + gradient.gradientRotation + ',' + gradient.color1 + ',' + gradient.color2 + ',' + gradient.color3 + ')' }"></div>
          <div class="gradient gradient-generator" v-else id="expanded-gradient"
               :class="[ isExpanded ? 'section-overlay' : '']"
               :style="{ 'background': gradient.gradientType + '(' + gradient.gradientRotation + ',' + gradient.color1 + ',' + gradient.color2 + ')' }"></div>
        </div>
      </div>

      <!-- BUTTONS ACTIONS -->
      <div class="row mb-3">
        <div class="col-md-12">

          <button class="btn btn-primary-light ripple ripple-dark" data-bs-toggle="modal" data-bs-target="#cssModal">
            <i class="material-icons-outlined">code</i>
            Copy css
          </button>
          <!-- MODAL CSS -->
          <ModalGradientCss :gradient="gradient" id="cssModal"></ModalGradientCss>

          <button class="btn btn-primary-light ripple ripple-primary" @click="toggleSidebarCodes">
            <i class="material-icons-outlined">code</i>
            Custom color codes
          </button>
          <SidebarCodesGradient :gradient="gradient" :is-sidebar-active="isSidebarActive"
                                :sidebar-toggle="toggleSidebarCodes"></SidebarCodesGradient>

          <!-- EXPAND BUTTON -->
          <button class="btn btn-fab m-0" @click="expandGradient"><i
              class="material-icons-outlined btn-fab-icon">{{ isExpanded ? 'close' : 'fullscreen' }}</i>
          </button>

          <!-- DOWNLOAD BUTTON -->
          <button class="btn btn-fab btn-fab-download m-0" @click="downloadGradient"
                  :class="[ isExpanded ? 'd-block' : 'd-none']"><i
              class="material-icons-outlined btn-fab-icon">download</i>
          </button>

        </div>
      </div>

      <!-- TABLE COLOR CONVERTER -->
      <div class="row mb-5">
        <div class="col-md-12">
          <TableGradientColors :gradient="gradient"></TableGradientColors>
        </div>
      </div>

      <!-- TESTING GRADIENT -->
      <div class="row mb-3">
        <div class="col-md-12 mb-3">
          <h2 class="typography-headline-md fw-500">How it looks?</h2>
          <h3 class="subtitle-1 text-muted"><span class="fw-bold text-gradient-animate">Note:</span> The color blindness filters
            doesn't work on some browsers</h3>
        </div>
        <div class="col-md-12 mb-3">
          <GradientTesting :gradient="gradient"></GradientTesting>
        </div>
      </div>

      <!-- UI COMPONENTS PREVIEW -->
      <div class="row mb-5">
        <div class="col-md-12 mb-3">
          <h2 class="typography-headline-md fw-500">UI components preview</h2>
        </div>
        <div class="col-md-12 mb-3">
          <ElementsPreviewGradient :gradient="gradient"></ElementsPreviewGradient>
        </div>
      </div>

    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from "@/components/includes/Navbar";
import Footer from "@/components/includes/Footer";
import firebase from 'firebase/app'
import 'firebase/firestore'
import VueAos from 'vue-aos'
import ModalGradientCss from "@/components/gradients/ModalGradientCss";
import GradientTesting from "@/components/gradients/GradientTesting";
import TableGradientColors from "@/components/gradients/TableGradientColors";
import {mapGetters} from "vuex";
import * as htmlToImage from 'html-to-image';
import ElementsPreviewGradient from "@/components/gradients/ElementsPreviewGradient";
import SidebarCodesGradient from "@/components/gradients/SidebarCodesGradient";

export default {
  name: 'UserGradient',
  metaInfo() {
    return {
      title: this.gradient.name + ' | Gradient',
    }
  },
  data() {
    return {
      gradient: {},
      isExpanded: false,
      isSidebarActive: false
    }
  },
  components: {
    SidebarCodesGradient,
    ElementsPreviewGradient,
    TableGradientColors, GradientTesting, Navbar, Footer, VueAos, ModalGradientCss
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted() {
    this.getGradient()
  },
  methods: {
    async getGradient() {
      const db = firebase.firestore()
      const gradient = await db.collection('users').doc(this.$route.params.userId).collection('gradients').doc(this.$route.params.gradientId).get()
      this.gradient = {id: gradient.id, ...gradient.data()}
    },
    expandGradient() {
      this.isExpanded = !this.isExpanded
    },
    toggleSidebarCodes() {
      this.isSidebarActive = !this.isSidebarActive
    },
    downloadGradient() {
      htmlToImage.toJpeg(document.getElementById('expanded-gradient'), {quality: 1})
          .then(function (dataUrl) {
            const link = document.createElement('a');
            link.download = 'gradient.jpeg';
            link.href = dataUrl
            link.click();
          })
    },
  }
}
</script>

<style scoped>
.gradient {
  transition: none !important;
}
</style>